import { UseFormReturn } from 'react-hook-form';
import { FormCreateJourneyDataType } from '@/features/forms/CrieSeuRoteiro/validationScheme';

export const handleDisabled = (methods: UseFormReturn<FormCreateJourneyDataType>, step: number) => {
  switch (step) {
    case 0: // TravelData
      return (
        methods.watch('travelReason') &&
        methods.watch('travelPlannedDate') &&
        methods.watch('travelDestinations')?.length &&
        // methods.watch('travelCitiesToVisit')?.length &&
        methods.watch('travelExperiencies')?.length &&
        methods.watch('travelBudget')?.length
      );

    case 1: // Passengers
    case 2: // Accommodation
      return true;
    case 3: // AdditionalInformation
      return methods.watch('purchasedFlight') === 'sim' || methods.watch('purchasedFlight') === 'não';
    case 4:
      return methods.watch('name') && methods.watch('email') && methods.watch('phone');
  }

  return false;
};
